import React from 'react';
import styles from './ImportType.css';

function ImportType(props) {
  const { currentStep, checked } = props;
  if (currentStep !== 2) {
    return null;
  }
  return (
    <div className={styles['container-content']}>
      <h4> Choose Import Type</h4>
      <div
        className={`${styles['single-radio']} ${
          checked && checked === 'new' ? styles['single-radio-active'] : ''
        }`}
        onClick={() => props.handleChange('new')}
      >
        <div
          className={`${styles['circle-radio']} ${
            checked && checked === 'new'
              ? `${styles['circle-radio-active']}`
              : ''
          }`}
        />
        <div>
          <h5>New Recipes</h5>
          <span>
            {' '}
            Add new recipes and overwrite your existing recipes. All recipes
            will be deleted and replaced.{' '}
          </span>
        </div>
      </div>
      <div
        className={`${styles['single-radio-disable']} ${
          checked && checked === 'update' ? styles['single-radio-active'] : ''
        }`}
      >
        <div
          className={`${styles['circle-radio']} ${
            checked && checked === 'update'
              ? `${styles['circle-radio-active']}`
              : ''
          }`}
        />
        <div>
          <div>
            <h5 className={styles['radio-title-disable']}>Update Recipes</h5>
            <div className={`label label-warning ${styles['label-title']}`}>
              Coming Soon
            </div>
          </div>
          <span className={styles['radio-description-disable']}>
            {' '}
            Update your existing recipes. Ingredients cannot be deleted, only
            altered.
          </span>
        </div>
      </div>
    </div>
  );
}

export default ImportType;
